import { OPEN_LOADER, CLOSE_LOADER } from "../actions/types";

const initialState = {
  open: false,
};

export default function infoReducers(state = initialState, action) {
  switch (action.type) {
    case OPEN_LOADER:
      return {
        ...state,
        open: true,
      };
    case CLOSE_LOADER:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
}